/** Régimes client pour lesquels le collecteur AIRSI prélève sur la base TTC. */
export const REGIMES_CLIENT_AIRSI = new Set(["micro", "tee", "informel", "inconnu"]);

export type RegimeFiscalClient = "rni" | "rsi" | "micro" | "tee" | "informel" | "inconnu";

export const REGIME_FISCAL_CLIENT_OPTIONS: { value: RegimeFiscalClient; label: string }[] = [
  { value: "rni", label: "Réel normal (RNI)" },
  { value: "rsi", label: "Réel simplifié (RSI)" },
  { value: "micro", label: "Microentreprise" },
  { value: "tee", label: "TEE" },
  { value: "informel", label: "Informel" },
  { value: "inconnu", label: "Inconnu" },
];

export function labelRegimeFiscalClient(v: string | null | undefined): string {
  const o = REGIME_FISCAL_CLIENT_OPTIONS.find((x) => x.value === v);
  return o?.label ?? v ?? "—";
}

/** À l’affichage : colonne SQL `regime_fiscal` ou repli sur l’ancien `regime_imposition` (FNE). */
export function regimeFiscalEffectifClient(c: {
  regime_fiscal?: string | null;
  regime_imposition?: string | null;
}): RegimeFiscalClient {
  const rf = c.regime_fiscal?.trim();
  if (rf && REGIME_FISCAL_CLIENT_OPTIONS.some((x) => x.value === rf)) return rf as RegimeFiscalClient;
  const ri = c.regime_imposition?.trim();
  const map: Record<string, RegimeFiscalClient> = {
    RNI: "rni",
    RS: "rsi",
    TEE: "tee",
    CF: "micro",
    Autre: "informel",
  };
  if (ri && map[ri]) return map[ri];
  return "inconnu";
}

/** Aligné sur le RPC create_facture_vente / update_facture_vente (arrondi 2 décimales). */
export function computeAirsiFactureVente(
  collecteur_airsi: boolean,
  taux_airsi_dossier: number,
  regime_fiscal_client: string | null | undefined,
  montant_ht: number,
  montant_tva: number
): { montant_airsi: number; taux_airsi: number; montant_ttc: number } {
  const regime = (regime_fiscal_client || "inconnu").trim().toLowerCase();
  const eligible = collecteur_airsi && REGIMES_CLIENT_AIRSI.has(regime);
  const taux = Number(taux_airsi_dossier) || 5;
  if (!eligible) {
    return { montant_airsi: 0, taux_airsi: 0, montant_ttc: montant_ht + montant_tva };
  }
  const base = montant_ht + montant_tva;
  const montant_airsi = Math.round(base * (taux / 100) * 100) / 100;
  return {
    montant_airsi,
    taux_airsi: taux,
    montant_ttc: montant_ht + montant_tva + montant_airsi,
  };
}
